import React, { useEffect, useState } from "react";
import { Form, Button, Col, InputGroup, FormControl } from "react-bootstrap";
import { withCookies } from "react-cookie";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import moment from "moment";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useTranslation } from "react-i18next";

import htmlToDraft from "html-to-draftjs";
import { EditorState, ContentState } from "draft-js";
import configVars from "../../config";

const Implementation = ({ selectedTask, board, config }) => {
  const allTaskTypes = config && config["task_type"];
  const allTaskStatus = config && config["task_status"];

  const [translation] = useTranslation("translations");

  const [users, setUsers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [title, setTitle] = useState({
    value: "",
    error: false,
  });
  const [action, setAction] = useState("");
  const [steps, setSteps] = useState("");
  const [support, setSupport] = useState("");
  const [benefits, setBenefits] = useState("");

  const [taskType, setTaskType] = useState(
    allTaskTypes ? Object.keys(allTaskTypes)[0] : null
  );
  const [status, setStatus] = useState("");
  const timeline = {
    startDate: selectedTask?.implementation_timeline_start
      ? moment(new Date(selectedTask?.implementation_timeline_start)).format(
          "MM/DD/YYYY"
        )
      : moment(new Date()).format("MM/DD/YYYY"),
    endDate: selectedTask?.implementation_timeline_end
      ? moment(new Date(selectedTask?.implementation_timeline_end)).format(
          "MM/DD/YYYY"
        )
      : moment(new Date()).format("MM/DD/YYYY"),
  };

  useEffect(() => {
    if (selectedTask) {
      setTitle({ value: selectedTask.title, error: false });

      let implementation_decided_action = null;
      if (selectedTask?.action_plan_decided_action) {
        implementation_decided_action =
          selectedTask?.action_plan_decided_action;
      } else if (selectedTask?.idea_for_change_description) {
        implementation_decided_action =
          selectedTask?.idea_for_change_description;
      } else if (selectedTask?.implementation_decided_action) {
        implementation_decided_action =
          selectedTask?.implementation_decided_action;
      } else if (selectedTask?.evaluation_result) {
        implementation_decided_action = selectedTask?.evaluation_result;
      }

      if (implementation_decided_action) {
        const contentBlock1 = htmlToDraft(implementation_decided_action);
        if (contentBlock1) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock1.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setAction(editorState);
        }
      }
      let concrete_steps = selectedTask?.concrete_steps;

      if (concrete_steps) {
        const contentBlock1 = htmlToDraft(concrete_steps);
        if (contentBlock1) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock1.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setSteps(editorState);
        }
      }
      let resources_and_support = selectedTask?.resources_and_support;

      if (resources_and_support) {
        const contentBlock1 = htmlToDraft(resources_and_support);
        if (contentBlock1) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock1.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setSupport(editorState);
        }
      }
      let benefits = selectedTask?.benefits;

      if (benefits) {
        const contentBlock1 = htmlToDraft(benefits);
        if (contentBlock1) {
          const contentState = ContentState.createFromBlockArray(
            contentBlock1.contentBlocks
          );
          const editorState = EditorState.createWithContent(contentState);
          setBenefits(editorState);
        }
      }
      if (selectedTask?.responsible_persons) {
        setUsers(selectedTask?.responsible_persons);
      }

      setStatus(selectedTask?.task_status?.term_id);
      setTaskType(selectedTask?.task_type?.term_id);
    }
  }, [selectedTask]);
  useEffect(() => {
    if (board) {
      setAllUsers(board?.associated_users);
    }
  }, [board]);

  return (
    <Form>
      <div>
        <Col>
          <div className="d-lg-flex flex-lg-column">
            <Form.Group className="mb-3">
              <Form.Label><b>{translation("title")}</b></Form.Label>
              <Form.Control
                type="text"
                placeholder={translation("task_forms.idea_bank.placeholder")}
                value={title?.value}
                disabled
                isInvalid={title?.error}
                style={{ fontSize: "14px", padding: "0.5rem 0.5rem" }}
              />
              {title?.error && (
                <Form.Control.Feedback type="invalid">
                  {translation("title_empty_warning")}
                </Form.Control.Feedback>
              )}
            </Form.Group>

            <Form.Group style={{ width: "100%" }}>
              <Form.Label>
                <b>{translation("task_forms.action_plan.field2.label")}</b>
              </Form.Label>
              <Typeahead
                id="basic-typeahead-multiple"
                labelKey="display_name"
                multiple
                disabled
                options={allUsers}
                onChange={(e) => {}}
                selected={users}
              />
            </Form.Group>
          </div>
        </Col>
        <Col className="">
          <div className="d-flex justify-content-center">
            {config &&
              allTaskTypes &&
              Object.keys(allTaskTypes)?.map((item, index) => {
                return (
                  <Col className="d-flex pe-2" key={index}>
                    <Button
                      variant={
                        parseInt(taskType) === parseInt(item)
                          ? "light-green"
                          : "outline-light-green"
                      }
                      className={`${
                        parseInt(taskType) === parseInt(item)
                          ? `text-white`
                          : `text-sy-black`
                      } rounded`}
                      style={{
                        width: "100%",
                        textTransform: "uppercase",
                        fontWeight: "bold",
                      }}
                      disabled
                    >
                      {allTaskTypes[item]?.name}
                    </Button>
                  </Col>
                );
              })}
          </div>

          <div className="d-flex justify-content-center mt-3">
            <InputGroup className="mb-2">
              <Form.Label style={{ width: "100%" }}>
                <b>{translation("task_forms.action_plan.field3.label")}</b>
              </Form.Label>

              <InputGroup.Text>
                <i className="fa fa-calendar" aria-hidden="true"></i>
              </InputGroup.Text>
              <DateRangePicker disabled initialSettings={timeline}>
                <FormControl
                  type="text"
                  placeholder={translation("add_time_period")}
                />
              </DateRangePicker>
            </InputGroup>
          </div>
        </Col>
      </div>

      <div className="d-flex mt-3">
        <Form.Label><b>{translation("status")}</b></Form.Label>
      </div>
      <div className="d-flex">
        {config &&
          allTaskStatus &&
          Object.keys(allTaskStatus)?.map((item, index) => {
            return (
              <button
                key={index}
                style={{
                  height: "32px",
                  width: "90px",
                  padding: "0px 0px",
                  fontSize: "13px",
                  borderRadius: "32px",
                  marginRight: "10px",
                }}
                type="button"
                className={` btn border-1 ${
                  status === allTaskStatus[item].term_id
                    ? `btn-sy-${allTaskStatus[item].slug} text-white`
                    : `btn-outline-sy-${allTaskStatus[item]?.slug}`
                }`}
                disabled
              >
                {allTaskStatus[item]?.name}
              </button>
            );
          })}
      </div>

      <Form.Group className="mb-3 mt-3">
        <Form.Label>
          <b>{translation("task_forms.action_plan.field6.label")}</b>
        </Form.Label>
        <Editor
          toolbar={configVars?.wysiwygToolbarOptions}
          editorState={action}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editor-wrapper"
          disabled
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label><b>{translation("concrete_steps")}</b></Form.Label>

        <Editor
          toolbar={configVars?.wysiwygToolbarOptions}
          toolbarOnFocus
          editorState={steps}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editor-wrapper"
          disabled
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label><b>{translation("resources_support")}</b></Form.Label>

        <Editor
          toolbar={configVars?.wysiwygToolbarOptions}
          toolbarOnFocus
          editorState={support}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editor-wrapper"
          disabled
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label><b>{translation("benefits")}</b></Form.Label>

        <Editor
          toolbar={configVars?.wysiwygToolbarOptions}
          toolbarOnFocus
          editorState={benefits}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editor-wrapper"
          disabled
        />
      </Form.Group>
    </Form>
  );
};

export default withCookies(Implementation);
